import merge from 'merge'
import RESCODE from '@/constants/res-code'

const defaultOptions = {
  use: ['response']
}

export default function (client, options) {
  const opts = merge(defaultOptions, options)

  const interceptors = {
    response: {
      success (res) {
        // if (res.data.code !== 0 && !RESCODE.BIND_CODE.includes(res.data.code) && res.data.code !== 200) {
        //   throw new Error(res.data.message)
        // }
        let popError = true
        for (let code in RESCODE) {
          if (RESCODE[code] instanceof Array) {
            popError = popError && !RESCODE[code].includes(res.data.code)
          } else {
            popError = popError && res.data.code !== RESCODE[code]
          }
        }
        if (popError) {
          throw new Error(res.data.message)
        }
        return res
      },
      error (e) {
        return Promise.reject(e)
      }
    }
  }

  opts.use.forEach(use => {
    client.interceptors[use].use(interceptors[use].success, interceptors[use].error)
  })

  return client
}



// WEBPACK FOOTER //
// ./src/apis/interceptors/res-code.js